import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';

// TODO: ld-tooltip will be replaced by ula-tooltip; this is a breaking change
import { TooltipContentComponent } from '../tooltip';
import { Utils } from './utils.service';
import { FormValidationService } from './form-validation.service';

@Component({
  selector: 'ula-ssn-input',
  templateUrl: './ula-ssn-input.template.html',
  styleUrls: ['./ula-input.style.css'],
})
export class UlaSsnInputComponent {
  @Input() validationForm: FormGroup;
  @Input() control: AbstractControl;
  // intentionally not using 'formControlName' because that sets up
  // form auto magic, which prevented displaying one value but having
  // a different (unmasked) value displayed in the UI
  @Input() controlName: string;
  @Input() displayName: string;
  @Input() shouldCheckIsDirty: boolean = false;

  @Input() name: string = null;
  @Input() qa: string;
  @Input() title: string = '';
  @Input() labelPrefix: string;
  @Input() label: string;
  // TODO: ld-tooltip will be replaced by ula-tooltip; this is a breaking change
  @Input() popover: string | TooltipContentComponent;
  @Input() popoverPlacement: 'top' | 'bottom' | 'left' | 'right' = 'right';
  @Input() minlength: number = null;
  @Input() placeholder: string = null;

  @Input() public readonly: boolean = false;
  @Input() public  disabled: boolean = false;
  @Input() public required: boolean = false;
  public _focused: boolean = false;

  private _blurEmitter: EventEmitter<FocusEvent> = new EventEmitter<FocusEvent>();
  private _focusEmitter: EventEmitter<FocusEvent> = new EventEmitter<FocusEvent>();
  public maxLength: number;

  @Output('blur')
  get onBlur(): Observable<FocusEvent> { return this._blurEmitter.asObservable(); }

  @Output('focus')
  get onFocus(): Observable<FocusEvent> { return this._focusEmitter.asObservable(); }

  @Output() onChange: EventEmitter<any> = new EventEmitter(false);

  @ViewChild('input') input: ElementRef;

  private updateValue(newControlValue: string = ''): void {
    const update = Utils.formatSSN(newControlValue);
    this.control.setValue(update);
    this.control.markAsTouched();
    this.onChange.emit(update);
  }

  constructor(formValidationService: FormValidationService) {
    this.maxLength = formValidationService.maxlength.ssn;
  }

  _handleFocus(event: FocusEvent) {
    this._focused = true;
    this._focusEmitter.emit(event);
  }

  _handleBlur(event: FocusEvent) {
    const input = this.input.nativeElement as HTMLInputElement;
    this.updateValue(input.value);
    this.control.markAsTouched();
    this._focused = false;
    this._blurEmitter.emit(event);
  }

  _handleKeyEvent(event: KeyboardEvent): boolean {
    const key = Utils.normalizeEventKey(event);
    if (/[0-9\-]/.test(key)) {
      if (this.input.nativeElement.value.replace(/[^\d]/, '').length < 9) {
        return true;
      } else {
        return false;
      }
    }

    switch (key) {
      case ('Backspace'):
      case ('Delete'):
      case ('Enter'):
      case ('Return'):
      case ('Tab'):
        return true;
      default:
        return false;
    }
  }

  onPaste() {
    return false;
  }

  hasErrors(): boolean {
    return this.validationForm &&
      this.control.errors &&
      (this.control.touched ||
      !this.shouldCheckIsDirty) &&
      !this._focused;
  }
}
